import {
  Button,
  Menu,
  MenuHandler,
  MenuItem,
  MenuList,
} from "@material-tailwind/react";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { FaRegDotCircle } from "react-icons/fa";
import { IoChevronBackOutline } from "react-icons/io5";
// import { LuCalendar, LuClock4 } from "react-icons/lu";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getServices, putServices } from "../../apiServices/apiServices";
import LoadingGif from "../../assets/loading_anim.gif";
import ManifoldReportTable from "../../components/common/ManifoldReportTable";
import ModifyTablePerm from "../../modal/admin/ModifyTablePerm";
import { MdOutlineMoreVert } from "react-icons/md";
import EmptyingReport from "../reports/EmptyingReport";
import { jwtDecode } from "jwt-decode";

function AdminControllerDetails() {
  const [controllerDetails, setControllerDetails] = useState({});
  const [manifoldReportData, setManifoldReport] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState({ manifold_table: false });
  const [modifyTableToggle, setModifyTableToggle] = useState({
    chngovr_report: 0,
    ws_report: 0,
    br_report: 0,
  });
  const location = useLocation().state;
  const navigate = useNavigate();
  const access_token = localStorage.getItem("gassol-admin-token");

  useEffect(() => {
    window.scrollTo(0, 0);

    fetchControllerDetails();
  }, []);

  const fetchControllerDetails = async () => {
    setLoading(true);

    try {
      const res = await getServices(
        `/api/hardware/data?hardware_id=${location.hardware_id}`
      );
      setLoading(false);

      if (res.responseCode === 200) {
        fetchManifoldReportData(res.responseData[0]?.branch);
        setControllerDetails(res.responseData[0]);
        setModifyTableToggle({
          ...modifyTableToggle,
          chngovr_report: res.responseData[0]?.reportInfo[0]?.chngovr_report,
          ws_report: res.responseData[0]?.reportInfo[0]?.ws_report,
          br_report: res.responseData[0]?.reportInfo[0]?.br_report,
        });
      } else {
        setControllerDetails({});
      }
    } catch (error) {
      setLoading(false);
      toast.error(error);
    }
  };

  const fetchManifoldReportData = async (branch_id) => {
    setLoading(true);
    try {
      const res = await getServices(
        `/api/device/manifold/runtime?branch_id=${branch_id}`,
        access_token
      );
      setLoading(false);

      if (res.responseCode === 200) {
        setManifoldReport(res.responseData.data);
      } else {
        setManifoldReport([]);
      }
    } catch (error) {
      setLoading(false);
      toast.error(error);
    }
  };

  const handleSetParameter = () => {
    navigate(`/admin/manage_parameters`, {
      state: {
        hardware_id: controllerDetails?.hardware_id,
        // type_of_cylinder: null,
        // manifold: null,
        // no_of_cylinder: [],
        // ws_status: "",
        // burner: null,
        // prlt: controllerDetails.prlt,
        // prht: controllerDetails.prht,
        // mfr: controllerDetails.mfr,
        // mfprd: controllerDetails.mfprd,
        // aco: "",
        isUpdate: false,
      },
    });
  };

  const handleUpdateParameter = () => {
    navigate(`/admin/manage_parameters`, {
      state: {
        hardware_id: controllerDetails?.hardware_id,
        // type_of_cylinder: controllerDetails.type_of_cylinder,
        // manifold: controllerDetails.manifoldInfo[0]?.no_of_manifold,
        // no_of_cylinder: controllerDetails.manifoldInfo[0]?.no_of_cylinder,
        // ws_status: controllerDetails.ws_status,
        // burner: controllerDetails.burner.toString(),
        // shift_pressure: controllerDetails.shift_pressure,
        // prlt: controllerDetails.prlt,
        // prht: controllerDetails.prht,
        // mfr: controllerDetails.mfr,
        // mfprd: controllerDetails.mfprd,
        // aco: controllerDetails.aco,
        isUpdate: true,
      },
    });
  };

  const handleUpdatePerm = async (e) => {
    e.preventDefault();

    try {
      const res = await putServices(
        `/api/hardware/activate/update?hardware_id=${location.hardware_id}`,
        {
          chngovr_report: modifyTableToggle.chngovr_report,
          ws_report: modifyTableToggle.ws_report,
          br_report: modifyTableToggle.br_report,
        },
        access_token
      );
      if (res.responseCode === 200) {
        fetchControllerDetails();
        setModal({ ...modal, manifold_table: false });
      } else {
        toast.error(res.responseMessage);
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const handleSetGLD = () => {
    navigate("/admin/gld_configuration", {
      state: { controllerDetails: controllerDetails },
    });
  };

  const handleUpdateGLD = () => {
    navigate("/admin/gld_configuration", {
      state: { controllerDetails: controllerDetails },
    });
  };

  return (
    <>
      <div className="py-4 md:py-8 max-w-[1400px] mx-auto px-3">
        <div className="flex gap-2 md:justify-between items-start md:items-center flex-col md:flex-row">
          <div className="flex gap-3 sm:gap-6">
            <Link
              to={-1}
              className="flex gap-2 items-center font-semibold text-xl text-[#BDBDBD]"
            >
              <IoChevronBackOutline />
              <p>Controller Details</p>
            </Link>
            {!loading && (
              <div
                className={`flex items-center gap-2 text-[15px] px-7 py-2 rounded-full ${
                  controllerDetails.running_status === 1
                    ? "text-yellow-600 bg-yellow-50"
                    : controllerDetails.running_status === 2
                    ? "text-green-600 bg-green-50"
                    : controllerDetails.running_status === 3
                    ? "text-red-600 bg-red-100"
                    : controllerDetails.running_status === 4
                    ? "text-red-600 bg-red-100"
                    : ""
                }`}
              >
                <FaRegDotCircle />
                <p>
                  {controllerDetails.running_status === 1
                    ? "Listed"
                    : controllerDetails.running_status === 2
                    ? "Activated"
                    : controllerDetails.running_status === 3
                    ? "Deactivated"
                    : controllerDetails.running_status === 4
                    ? "Activation Pending"
                    : "-"}
                </p>
              </div>
            )}
          </div>
          {!loading && (
            <div className="text-[#BDBDBD] text-right flex justify-end md:block w-full md:w-[unset]">
              Activated on: {controllerDetails.actvtd_on ?? "-"}
            </div>
          )}
        </div>

        {!loading ? (
          <>
            <div className="flex justify-end items-center mt-3 gap-3">
              {controllerDetails.running_status === 4 ? (
                <Button
                  onClick={handleSetParameter}
                  className="font-poppins font-medium tracking-wider bg-[#03438D]"
                >
                  Set Parameters
                </Button>
              ) : (
                <Button
                  onClick={handleUpdateParameter}
                  className="font-poppins font-medium tracking-wider bg-[#03438D]"
                >
                  Update Parameters
                </Button>
              )}

              {controllerDetails.running_status !== 4 && (
                <>
                  {Array.isArray(controllerDetails.reportInfo) &&
                  controllerDetails.reportInfo[0]?.gld_report === 1 ? (
                    <Button
                      onClick={handleUpdateGLD}
                      className="font-poppins font-medium tracking-wider bg-[#03438D]"
                    >
                      Update GLD Configuration
                    </Button>
                  ) : (
                    <Button
                      onClick={handleSetGLD}
                      className="font-poppins font-medium tracking-wider bg-[#03438D]"
                    >
                      Set GLD Configuration
                    </Button>
                  )}
                </>
              )}
            </div>

            <div className="flex md:justify-between md:items-center flex-col md:flex-row gap-1 sm:gap-2 mt-3">
              <div>
                <p className="text-[#BDBDBD] text-sm">Hardware ID</p>
                <p className="text-black font-bold text-4xl">
                  #{controllerDetails.hardware_id ?? "-"}
                </p>
              </div>
              <div className="md:text-right">
                <p className="text-[#BDBDBD] flex items-center gap-2">
                  Company Name:{" "}
                  <span className="font-bold text-black text-xl capitalize">
                    {location?.controller_data?.company_name}
                  </span>
                </p>
                <p className="text-[#BDBDBD] flex items-center gap-2">
                  Branch:{" "}
                  <span className="font-bold text-black text-xl capitalize">
                    {location?.controller_data?.branch}
                  </span>
                </p>
              </div>
            </div>

            <div className="mt-6">
              <div className="grid lg:grid-cols-2 gap-5">
                <div className="flex flex-col gap-5">
                  <div className="drop-shadow-2xl bg-white py-6 sm:py-10 px-5 sm:px-10 rounded-3xl h-fit flex flex-col gap-5">
                    <p className="text-[13px] text-[#BDBDBD] font-medium">
                      Contact Info
                    </p>
                    <p className="text-sm text-[#BDBDBD]">
                      Contact Person Name:{" "}
                      <span className="text-black font-semibold">
                        {controllerDetails.co_person ?? "-"}
                      </span>
                    </p>
                    <p className="text-sm text-[#BDBDBD]">
                      Phone no.:{" "}
                      <span className="text-black font-semibold">
                        {controllerDetails.co_person_no ?? "-"}
                      </span>
                    </p>
                    <p className="text-sm text-[#BDBDBD]">
                      Email Address:{" "}
                      <span className="text-black font-semibold">
                        {controllerDetails.co_person_email ?? "-"}
                      </span>
                    </p>
                  </div>

                  <div className="drop-shadow-2xl bg-white py-6 sm:py-10 px-5 sm:px-10 rounded-3xl h-fit flex flex-col gap-5">
                    <p className="text-[13px] text-[#BDBDBD] font-medium">
                      Address
                    </p>
                    <p className="text-sm text-[#BDBDBD]">
                      District:{" "}
                      <span className="text-black font-semibold">
                        {controllerDetails.district ?? "-"}
                      </span>
                    </p>
                    <p className="text-sm text-[#BDBDBD]">
                      State:{" "}
                      <span className="text-black font-semibold">
                        {controllerDetails.state ?? "-"}
                      </span>
                    </p>
                    <p className="text-sm text-[#BDBDBD]">
                      Pin code:{" "}
                      <span className="text-black font-semibold">
                        {controllerDetails.pincode ?? "-"}
                      </span>
                    </p>
                  </div>
                </div>

                <div className="drop-shadow-2xl bg-white py-6 sm:py-10 px-5 sm:px-10 lg:px-20 rounded-3xl h-fit">
                  <p className="font-medium text-[#BDBDBD] text-[13px]">
                    For Normal Communication
                  </p>
                  <div className="mt-4 grid grid-cols-2">
                    <div className="flex flex-col gap-3">
                      {controllerDetails?.communication?.normal_email
                        ?.filter((item) => item !== "")
                        ?.map((email, i) => (
                          <p
                            key={i}
                            className="text-sm text-[#BDBDBD] font-medium"
                          >
                            Email {i + 1}:{" "}
                            <span className="text-black">{email}</span>
                          </p>
                        ))}
                    </div>

                    <div className="flex flex-col gap-3 items-end">
                      {controllerDetails?.communication?.normal_phone
                        ?.filter((item) => item !== "")
                        ?.map((phone, i) => (
                          <p
                            key={i}
                            className="text-sm text-[#BDBDBD] font-medium"
                          >
                            Phone {i + 1}:{" "}
                            <span className="text-black">{phone}</span>
                          </p>
                        ))}
                    </div>
                  </div>

                  <hr className="my-8 w-[90%] mx-auto border-[#BDBDBD] border-t-2" />

                  <p className="font-medium text-[#BDBDBD] text-[13px]">
                    For Critical Communication
                  </p>
                  <div className="mt-6 grid grid-cols-2">
                    <div className="flex flex-col gap-3">
                      {controllerDetails?.communication?.critical_email
                        ?.filter((item) => item !== "")
                        ?.map((email, i) => (
                          <p
                            key={i}
                            className="text-sm text-[#BDBDBD] font-medium"
                          >
                            Email {i + 1}:{" "}
                            <span className="text-black">{email}</span>
                          </p>
                        ))}
                    </div>

                    <div className="flex flex-col gap-3 items-end">
                      {controllerDetails?.communication?.critical_phone
                        ?.filter((item) => item !== "")
                        ?.map((phone, i) => (
                          <p
                            key={i}
                            className="text-sm text-[#BDBDBD] font-medium"
                          >
                            Phone {i + 1}:{" "}
                            <span className="text-black">{phone}</span>
                          </p>
                        ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-5 md:mt-8">
              <div className="flex justify-end mb-4 gap-3 flex-wrap sm:flex-nowrap">
                {controllerDetails.running_status === 2 && (
                  <Button
                    onClick={() => setModal({ ...modal, manifold_table: true })}
                    className="font-poppins font-medium tracking-wider bg-[#03438D]"
                  >
                    Modify Table Permission
                  </Button>
                )}
                {/* <Button
                  onClick={() => {
                    window.open(
                      `/admin/controller_details/burner_report/${controllerDetails.branch}`,
                      "_blank"
                    );
                  }}
                  className="font-poppins font-medium tracking-wider bg-[#03438D]"
                >
                  Burner Report
                </Button>
                <Button
                  onClick={() => {
                    window.open(
                      `/admin/controller_details/cylinder_weight_report/${controllerDetails.branch}`,
                      "_blank"
                    );
                  }}
                  className="font-poppins font-medium tracking-wider bg-[#03438D]"
                >
                  Cylinder Report
                </Button> */}
                {controllerDetails?.reportInfo?.[0]?.gld_report !== 0 && (
                  <Button
                    onClick={() => {
                      navigate("/admin/gld_logs", {
                        state: { controllerDetails: controllerDetails },
                      });
                    }}
                    className="font-poppins font-medium tracking-wider bg-[#03438D]"
                  >
                    GLD Logs
                  </Button>
                )}

                <Menu placement="left-start">
                  <MenuHandler title="Click to open reports">
                    <Button className="p-2 rounded-full bg-[#03438D] outline-none">
                      <MdOutlineMoreVert className="text-2xl" />
                    </Button>
                  </MenuHandler>
                  <MenuList>
                    {controllerDetails?.reportInfo?.[0]?.br_report === 1 && (
                      <MenuItem
                        onClick={() => {
                          window.open(
                            `/controller_details/burner_report/${controllerDetails.branch}`,
                            "_blank"
                          );
                        }}
                        className="font-poppins"
                      >
                        Burner Report
                      </MenuItem>
                    )}
                    <MenuItem
                      onClick={() => {
                        window.open(
                          `/controller_details/cylinder_weight_report/${controllerDetails.branch}`,
                          "_blank"
                        );
                      }}
                      className="font-poppins"
                    >
                      Cylinder Report
                    </MenuItem>
                    {/* {decode.role === 2 && ( */}
                    <MenuItem
                      onClick={() => {
                        window.open(
                          `/controller_details/emptying_report/${controllerDetails.branch}`,
                          "_blank"
                        );
                      }}
                      className="font-poppins"
                    >
                      Emptying Report
                    </MenuItem>
                    {/* )} */}
                    <MenuItem
                      onClick={() => {
                        window.open(
                          `/controller_details/offline_report/${controllerDetails.branch}`,
                          "_blank"
                        );
                      }}
                      className="font-poppins"
                    >
                      Offline Report
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        window.open(
                          `/controller_details/offtime_report/${controllerDetails.branch}`,
                          "_blank"
                        );
                      }}
                      className="font-poppins"
                    >
                      Off-time Report
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        window.open(
                          `/controller_details/graph_view/${controllerDetails.branch}`,
                          "_blank"
                        );
                      }}
                      className="font-poppins"
                    >
                      Graph View
                    </MenuItem>
                  </MenuList>
                </Menu>
              </div>

              {/* manifold report */}
              {/* {controllerDetails ? ( */}
              {manifoldReportData.length > 0 ? (
                <>
                  <ManifoldReportTable
                    manifoldReportData={manifoldReportData}
                    controllerDetails={controllerDetails}
                  />
                  {/* <EmptyingReport branch_id={controllerDetails.branch} /> */}
                </>
              ) : (
                <div className="text-center h-[50vh] flex flex-col justify-center items-center text-black">
                  <p className="font-semibold text-xl sm:text-3xl">
                    Oops! No Data Found...
                  </p>
                  <p className="text-sm mt-2 ">
                    Looks like we couldn't find any branch that match your
                    search right now.
                  </p>
                </div>
              )}
            </div>
          </>
        ) : (
          <div className="w-full flex justify-center items-center h-[60vh]">
            <img src={LoadingGif} alt="" />
          </div>
        )}
      </div>

      <ModifyTablePerm
        open={modal.manifold_table}
        onClose={() => setModal({ ...modal, manifold_table: false })}
        handleUpdatePerm={handleUpdatePerm}
        modifyTableToggle={modifyTableToggle}
        setModifyTableToggle={setModifyTableToggle}
      />
    </>
  );
}

export default AdminControllerDetails;
